import { createUseStyles } from 'react-jss'

export const useStyles = createUseStyles(theme => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20
  },

  logo: {
    width: 84
  },

  login: {
    color: theme.neonPrimary,
    fontSize: 16,
    lineHeight: 0.95,
    paddingBottom: 2,
    borderBottom: '1px solid transparent',

    '&:hover': {
      borderBottom: `1px solid ${theme.neonPrimary}`
    },

    [theme.media.tablet]: {
      fontSize: 20
    }
  }
}))
